import { render, staticRenderFns } from "./tipo-documento.vue?vue&type=template&id=80cc8028"
import script from "./tipo-documento.vue?vue&type=script&lang=js"
export * from "./tipo-documento.vue?vue&type=script&lang=js"
import style0 from "./tipo-documento.vue?vue&type=style&index=0&id=80cc8028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports